var map = {
	"./addr/addr.js": "e42d",
	"./app.js": "d9cd",
	"./captcha.js": "baa7f",
	"./cart/cart.js": "0c6c",
	"./categories.js": "fd2e",
	"./channel.js": "a24b",
	"./comCart.js": "67bc",
	"./goodDetails/goodDetails.js": "48de",
	"./goods/goods.js": "df0a",
	"./group/goods.js": "34e1",
	"./index.js": "2a74",
	"./list.js": "3d84",
	"./member/member.js": "192a",
	"./order/confirmOrder.js": "8205",
	"./order/refund.js": "8145",
	"./order/replaceVouher.js": "cfb6",
	"./order/signature.js": "72ba",
	"./pickUp.js": "f930",
	"./shop/shopDetails.js": "b691",
	"./shop/shopPoints.js": "480b",
	"./treaty/paymentOnBehalf.js": "1dc5",
	"./vip.js": "ad63",
	"./weiXin/weixin.js": "8935"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";